export default {"src":"/_next/static/media/retail_dleteren.cfe0ecc8.svg","height":89,"width":418,"blurWidth":0,"blurHeight":0};